//InfoCard

import { Button } from "@/components/ui/Button";
import { CLEAN_STRING_REGEX } from "@/config/constants";
import { cn } from "@/lib/utils";
import { normalizeTextToArray } from "@/utils/formatText";
import { useState } from "react";

const MAX_ITEM_RENDER = 3;

const InfoCard = ({ title, icon: Icon, iconBg, iconColor, gradient, glowColor, text = "N/A", blur = "70px" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Convert text to array
  const items = normalizeTextToArray(text);

  // Truncate if needed
  const needsTruncation = items.length > MAX_ITEM_RENDER;
  const displayItems = isExpanded || !needsTruncation ? items : items.slice(0, MAX_ITEM_RENDER);

  return (
    <div className="flex">
      <div className={cn(`p-[1px] rounded-xl w-full flex `)}>
        <div className="relative rounded-xl overflow-hidden bg-background-tertiary/30 text-text-primary w-full border border-border-primary">
          <div className={`p-3`}>
            {/* Header */}
            <div className="flex items-center gap-2 mb-2">
              <div className={`${iconBg} p-2 rounded-full`}>
                <Icon size={16} className={iconColor} />
              </div>
              <p className="text-sm font-medium">{title}</p>
            </div>

            {/* Content */}
            <div>
              <ul className="text-sm list-disc list-inside space-y-1">
                {displayItems.length > 0 ? displayItems.map((item, i) => <li key={i}>{item.trim()}</li>) : "N/A"}
              </ul>

              {needsTruncation && (
                <Button onClick={() => setIsExpanded(!isExpanded)} className="text-xs text-text-blue mt-1 focus:outline-none">
                  {isExpanded ? "Show less" : `+${items.length - 3} more`}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
